
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment = {
    production: true,
    googleMapsApiKey: '',
    API_URL: 'https://dev-api.kumorai.io/api/',
    WORKER_URL: 'https://dev-worker.kumorai.io/',
    CLIENT_URL: 'http://localhost:4200/',
    FILE_NAME: 'local-environment',
    CLIENT_NAME: 'Development',
    INDEXED_DB_NAME: 'KumoraiDBDev',
    INDEXED_DB_Version: 6,
    BUILD_VERSION: 'V 5.0.23'
};
